import component from './src/search-item.vue';
export default {
  install(Vue){
    Vue.component(component.name, component);
  }
}



// WEBPACK FOOTER //
// ./src/framework/components/base/search-item/index.js